import { render, staticRenderFns } from "./PlayerEvents.vue?vue&type=template&id=2c9974ec&scoped=true&"
import script from "./PlayerEvents.vue?vue&type=script&lang=js&"
export * from "./PlayerEvents.vue?vue&type=script&lang=js&"
import style0 from "./PlayerEvents.vue?vue&type=style&index=0&id=2c9974ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9974ec",
  null
  
)

export default component.exports